var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',_vm._g(_vm._b({attrs:{"color":_vm.color,"depressed":"","small":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'v-btn',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }